import Vue, { inject, provide, ref } from "vue";
import { VBtn, VCard, VCardActions, VCardText, VDialog, VRadio, VRow, VSpacer } from "vuetify/lib";
import { InstructionsModalProviderKey } from "@/constants/keys";
import { mapState } from "vuex";
import { useInstructionsModal, useInstructionsStore } from "./useInstructionsModal";

export interface InstructionsModalApiInjection {

    show: (message: string) => void
    hide: () => void
}

export const InstructionsModalProvider = Vue.extend({
    name: "InstructionsModalProvider",
    extends: VDialog,
    store: useInstructionsStore,

    computed: {

        dialogState: {
            get() {
                return this.$store.state.dialogState;
            },

            set(value) {
                this.$store.commit('hideDialog')
            }
        },

        dialogMessage() {
            return this.$store.state.dialogMessage
        }
    },

    methods: {
        hideDialog() {
            this.$store.commit('hideDialog')
        }
    },

    render() {
        return (
            <VDialog tile max-width="320" vModel={this.dialogState}>
                <VCard flat tile min-height="180" class="d-flex flex-column">
                    <VCardText><p class="pa-2">{this.dialogMessage}</p></VCardText>
                    <VSpacer />
                    <VCardActions>
                        <VRow no-gutters align="end" justify="end">
                            <VBtn depressed color="primary" onClick={() => this.hideDialog()}>Fechar</VBtn>
                        </VRow>
                    </VCardActions>
                </VCard>
            </VDialog>
        )
    }
})
